export const REQUEST_REPOSITORIES = 'REQUEST_REPOSITORIES';
export const SUCCESS_REPOSITORIES = 'SUCCESS_REPOSITORIES';
export const FAILURE_REPOSITORIES = 'FAILURE_REPOSITORIES';
export const CLEAR_REPOSITORIES = 'CLEAR_REPOSITORIES';
